import React from "react";
import NewsFormPage from "../components/news/NewsFormPage";

const NewsEdit = () => <NewsFormPage mode="edit" />;

export default NewsEdit;
